import React from "react";

const PasswordStrength = ({ password }) => {

  const calculateStrength = () => {

    let strength = 0;

    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[@$!%*?&]/.test(password)) strength++;

    return strength;
  };

  const strength = calculateStrength();

  const labels = ["Weak", "Fair", "Good", "Strong"];

  return (
    <div>

      {password && (
        <p>
          Password Strength: {labels[strength - 1] || "Weak"}
        </p>
      )}

      <div className="strength-bar">

        <div
          className="strength-fill"
          style={{ width: `${strength * 25}%` }}
        ></div>

      </div>

    </div>
  );
};

export default PasswordStrength;